export default class FormOverlay {
  constructor() {
    this.DOM = {
      openEls: document.querySelectorAll('[data-form-open]'),
      formEls: document.querySelectorAll('[data-form]'),
      closeEls: document.querySelectorAll('[data-form-close]')
    }
  }

  init() {
    if (!this.DOM.openEls.length ||
        !this.DOM.formEls.length ||
        !this.DOM.closeEls.length) return;
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.openEls.forEach(el => el.addEventListener('click', this.onOpenClick.bind(this)));
    this.DOM.closeEls.forEach(el => el.addEventListener('click', this.onCloseClick.bind(this)));
  }

  onOpenClick(e) {
    e.preventDefault();
    const currentForm = e.currentTarget.getAttribute('data-form-open');

    this.DOM.formEls.forEach(formEl => {
      if (formEl.getAttribute('data-form') === currentForm) {
        formEl.classList.add('is-open');
      }
    })

    const htmlEl = document.querySelector('html');
    document.body.classList.add('is-scroll-off');
    htmlEl.classList.add('is-scroll-off');
  }

  onCloseClick(e) {
    e.preventDefault();
    const currentForm = e.currentTarget.getAttribute('data-form-close');

    this.DOM.formEls.forEach(formEl => {
      if (formEl.getAttribute('data-form') === currentForm) {
        formEl.classList.remove('is-open');
      }
    })

    const htmlEl = document.querySelector('html');
    document.body.classList.remove('is-scroll-off');
    htmlEl.classList.remove('is-scroll-off');
  }
}